// 日期格式化
/*
  传入参数列表
    d: date Object | number(毫秒/秒) | string(已经格式化的日期) | default: 当前时间
    type: 'datetime' | 'second' | default: date
  demo:
    formatDate()  "2017-03-28"
    formatDate(new Date(), 'datetime') "2017-03-15 15:34"
*/
import Vue from 'vue'

export const formatDate = function (d, type) {
  if (!d) {
    d = timeZone(new Date())
  } else if (typeof d === 'object') {
    d = timeZone(d)
  } else if (typeof d === 'number') {
    if (d.toString().length === 10) {
      d = d * 1000
    }
    d = timeZone(d)
  } else {
    // 判断所传入的日期是否为有效日期，如果不是，则返回当日时间
    d = new Date(d)
    const isValidDate = d.getTime().toString() !== 'NaN'

    // 所传入的日期为有效日期，且年份不得大于9999
    if (isValidDate && d.getYear() < 9999) {
      d = timeZone(d)
    } else {
      d = timeZone(new Date())
    }
  }

  // 输出 datetime
  if (type === 'datetime') {
    return d.toISOString().substring(0, 16).replace('T', ' ')
  } else if (type === 'seconds') {
    return d.toISOString().substring(0, 19).replace('T', ' ').substring(11, 19)
  }

  // 输出 date
  return d.toISOString().slice(0, 10)
}

// 因为toISOString默认转为格林尼治时间，所以在转换之前需要额外加上8个小时
function timeZone (time) {
  if (typeof time === 'object') {
    time = time.getTime()
  }
  return new Date(time + 28800000)
}

// 解析JSON Object，并加入异常处理
/*
  传入参数列表
    str: 要解析的字符串
    def: 如果解析失败，所返回的默认值，不填则返回一个空数组
  demo:
    json('{key: value}', {})
*/

export const json = function (str, def) {
  try {
    return JSON.parse(str)
  } catch (e) {
    console.warn('捕获异常：', e, str)
    return def || []
  }
}

// 与现在时间做比较
/*
传入参数列表
time: 需要比较的时间（秒）
demo:
1分钟内： '刚刚'
1小时内： 'xx分钟前'
5小时内： 'xx小时前'
超过5小时但在今日内： '今日 hh:mm'
其他时间：'DD-MM hh:mm'
*/
export const formatTimeCompare = function (time) {
  time = Number(time)
  if (!time) {
    return
  }
  // 只需要精确到秒
  let curTime = parseInt(new Date().getTime() / 1000)

  // 现在时间与传入的时间做比较
  let poor = curTime - time

  // 今日零点的时间戳（取的秒）
  let curDay = parseInt(new Date(new Date().setHours(0, 0, 0, 0)) / 1000)

  if (parseInt(poor / 60) <= 0) { // 1 分钟内
    return '刚刚'
  } else if (parseInt(poor / 60) < 60) { // 1小时内
    return parseInt(poor / 60) + '分钟前'
  } else if (parseInt(poor / 3600) < 5) { // 5小时内
    return parseInt(poor / 3600) + '小时前'
  } else if (curDay < time) { // 超过5小时但在今日内
    return '今日 ' + formatDate(time, 'datetime').slice(11)
  } else {
    return formatDate(time, 'datetime').slice(5)
  }
}

// 以下是处理javascript小数精度加减乘除的四个的函数
/**
 * 必需要传的前两个参数:传入两个要计算的数字
 * 非必要传的最后一个参数:自己想要精确的位数
 */

// 计算两位数应该乘以的数，为加减乘数服务的函数
function formatNumber (num1, num2) {
  let r1, r2
  try {
    r1 = num1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = num2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  let sum = r1 + r2
  let sub = r2 - r1
  return { 'max': Math.pow(10, Math.max(r1, r2)), 'sum': Math.pow(10, sum), 'sub': Math.pow(10, sub), 'len': Math.max(r1, r2) }
}

// 加法
export const plus = function (num1, num2, n) {
  let formatNum = formatNumber(num1, num2).max * 100
  let result = (num1 * formatNum + num2 * formatNum) / formatNum
  if (n) {
    return result.toFixed(n)
  }
  let len = formatNumber(num1, num2).len
  return Number(result.toFixed(len))
}

// 减法
export const subtract = function (num1, num2, n) {
  let formatNum = formatNumber(num1, num2).max * 100
  let result = (num1 * formatNum - num2 * formatNum) / formatNum
  if (n) {
    return result.toFixed(n)
  }
  let len = formatNumber(num1, num2).len
  return Number(result.toFixed(len))
}

// 乘法
export const multiply = function (num1, num2, n) {
  let sum = formatNumber(num1, num2).sum
  let s1 = Number(num1.toString().replace('.', ''))
  let s2 = Number(num2.toString().replace('.', ''))
  let result = (s1 * s2) / sum
  if (n) {
    return result.toFixed(n)
  }
  return result
}

// 除法
export const divide = function (num1, num2, n) {
  let sub = formatNumber(num1, num2).sub
  let r1 = Number(num1.toString().replace('.', ''))
  let r2 = Number(num2.toString().replace('.', ''))
  let result = (r1 / r2) * sub
  if (n) {
    return result.toFixed(n)
  }
  return result
}

export const isDingTalk = function () {
  let flag
  let userAgent = window.navigator.userAgent
  flag = /DingTalk/i.test(userAgent)
  return flag
}

export const openBlankUrl = function (url) {
  if (isDingTalk()) {
    return '/user/autoLogin.do?t=' + Vue.cookies.get('t').replace(/"/g, '') + '&nonce=' + Vue.cookies.get('nonce').replace(/"/g, '') + '&redirectUrl=' + encodeURIComponent(url)
  } else {
    return url
  }
}

export const getStrLength = function (str) {
  let len = 0
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
      len += 2
    } else {
      len++
    }
  }
  return len
}

// 获取URL参数
export const query = function (search) {
  let str = search || window.location.search
  let objURL = {}

  str.replace(
    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
    ($0, $1, $2, $3) => {
      objURL[$1] = $3
    }
  )
  return objURL
}

/**
 * @description 获取用于预览的文件类型
 * @param {String} ext 文件后缀名
 * @returns fileViewType
 */
export function getFileViewType (ext) {
  const viewFile = {
    image: 'jpg/png/jpeg/gif/bmp',
    office: 'xlsx/xlsb/xlsm/docx/dotx/pptx/ppsx/potx/ppsm',
    audio: 'mp3/aac/wav/ogg',
    video: 'mp4',
    pdf: 'pdf'
  }

  if (!ext) return ''
  for (const key in viewFile) {
    if (viewFile[key].indexOf(ext) > -1) {
      return key
    }
  }
  return ''
}

/**
 * @description 获取文件类型，用于显示文件图标
 * @param {String} ext 文件后缀名
 * @returns fileType
 */
export function getFileType (ext) {
  const fileType = {
    image: 'jpg/png/jpeg/gif/bmp/raw',
    txt: 'txt/log',
    zip: 'zip/rar/tar/gz',
    sounds: 'mp3/wav/wma/cda/midi/ogg/ape/flac/aac',
    excel: 'xls/xlsx/csv/et/ett/xlt',
    pdf: 'pdf',
    word: 'doc/docx/docm/dotx/wps/wpt/rtf',
    ppt: 'ppt/pptx/dps/dpt/pot/pps',
    video: 'mp4/avi/wmv/mov/mkv',
    html: 'html/xml/dhtml'
  }

  if (!ext) return 'other'
  for (const key in fileType) {
    if (fileType[key].indexOf(ext) > -1) {
      return key
    }
  }
  return 'other'
}



// WEBPACK FOOTER //
// ./src/utils.js